
import React from "react";
import { useState, useEffect } from "react";
import { FooterComponents } from "../../../components/FooterComponents/FooterComponents";
import { json } from "stream/consumers";
import { Link } from "react-router-dom";
import "./DownLoadContact.css";
import { Layout } from "antd";



const DownloadContactTemplate = () => {
    const _basePath = window.location.hostname;
    // const _templatePath = [
    //     'TemplateNumber_1',
    //     'TemplateNumber_2',
    //     'TemplateNumber_3'
    // ]
    const GeneratePanelDownload = (num: any, title: any, path: any) => {
        return (<div className="col-md-4 card-container bg-gray-white" style={{ minHeight: "80px", margin : "2px 0px 2px 0px"}}>
            <p className="font-size-20">
                {num}). {title}
                <button title={"button_" + num} className="btn-download-contact p-button p-component undefined ButtonComponents-background"
                onClick={() => DownLoadFile(path)}> Download</button>
            </p>
        </div>);
    }
    const DownLoadFile = (fileName : any) => {
        window.open("/"+ fileName,"_blank");
    }
    return (
        <div className="cards-container bg-gray">
            <div className="card-container">
                <div className="card-container bg-white" style={{ minHeight: "80px", marginTop: "10px" }}>
                    <div className="route-text-container">
                        <p className="route-text under-line"><h2>สัญญาจ้าง</h2></p>
                    </div>
                    <div className="row set-margin-in-row-add-control">
                        {GeneratePanelDownload("1", "แบบสัญญาจ้าง", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/1_แบบสัญญาจ้าง.docx")}
                        {GeneratePanelDownload("2", "สัญญาจ้างที่ปรึกษา", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/2_สัญญาจ้างที่ปรึกษา.docx")}
                        {GeneratePanelDownload("3", "สัญญาจ้างก่อสร้าง", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/3_สัญญาจ้างก่อสร้าง.docx")}
                        {GeneratePanelDownload("4", "สัญญาจ้างออกแบบและควบคุมงาน", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/4_สัญญาจ้างออกแบบและควบคุมงาน.docx")}
                        {GeneratePanelDownload("5", "แบบสัญญาจ้างทำความสะอาดอาคาร", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/5_แบบสัญญาจ้างทำความสะอาดอาคาร.docx")}
                        {GeneratePanelDownload("6", "แบบสัญญาจ้างบริการรักษาความปลอดภัย", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/6_แบบสัญญาจ้างบริการรักษาความปลอดภัย.docx")}
                        {GeneratePanelDownload("7", "สัญญาจ้างบริการบำรุงรักษาและซ่อมแซม", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/7_สัญญาจ้างบริการบำรุงรักษาและซ่อมแซม.docx")}
                        {GeneratePanelDownload("8", "สัญญาจ้างบริการป้องกันและกำจัดแมลง", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/8_สัญญาจ้างบริการป้องกันและกำจัดแมลง.docx")}
                        {GeneratePanelDownload("9", "สัญญาจ้างบำรุงรักษาระบบคอมพิวเตอร์", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/9_สัญญาจ้างบำรุงรักษาระบบคอมพิวเตอร์.docx")}
                        {GeneratePanelDownload("10", "สัญญาจ้างพัฒนาระบบ", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/10_สัญญาจ้างพัฒนาระบบ.docx")}
                    </div>
                </div>
                <div className="card-container bg-white" style={{ minHeight: "80px", marginTop: "10px" }}>
                    <div className="row set-margin-in-row-add-control">
                        <div className="route-text-container">
                            <p className="route-text under-line"><h2>สัญญาจะซื้อจะขาย / แลกเปลี่ยน</h2></p>
                        </div>
                        {GeneratePanelDownload("1", "แบบสัญญาซื้อขาย", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/1_แบบสัญญาซื้อขาย.docx")}
                        {GeneratePanelDownload("2", "แบบสัญญาจะซื้อจะขาย", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/2_แบบสัญญาจะซื้อจะขาย.docx")}
                        {GeneratePanelDownload("3", "แบบสัญญาซื้อขายคอมพิวเตอร์", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/3_แบบสัญญาซื้อขายคอมพิวเตอร์.docx")}
                        {GeneratePanelDownload("4", "สัญญาซื้อขายและอนุญาตให้ใช้สิทธิในโปรแกรม", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/4_สัญญาซื้อขายและอนุญาตให้ใช้สิทธิในโปรแกรม.docx")}
                        {GeneratePanelDownload("5", "สัญญาแลกเปลี่ยน", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/5_สัญญาแลกเปลี่ยน.docx")}
                    </div>
                </div>
                <div className="card-container bg-white" style={{ minHeight: "80px", marginTop: "10px" }}>
                    <div className="row set-margin-in-row-add-control">
                        <div className="route-text-container">
                            <p className="route-text under-line"><h2>สัญญาเช่า</h2></p>
                        </div>
                        {GeneratePanelDownload("1", "สัญญาเช่าคอมพิวเตอร์", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/1_สัญญาเช่าคอมพิวเตอร์.docx")}
                        {GeneratePanelDownload("2", "สัญญาเช่าเครื่องถ่ายเอกสาร", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/2_สัญญาเช่าเครื่องถ่ายเอกสาร.docx")}
                        {GeneratePanelDownload("3", "สัญญาเช่ารถยนต์", "Document_Library/Xz9mfAw82EakF4LucAgsFA==/3_สัญญาเช่ารถยนต์.docx")}
                    </div>
                </div>
            </div>
            <FooterComponents />
        </div >
    );
}
export default DownloadContactTemplate;